import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Divider } from '@mui/material';
import { Section, SectionAlternate } from 'components/organisms';
import {
  // Browsers,
  // Features,
  // Integrations,
  // Partners,
  HeroSection,
  SolutionDetails
  // Subscription,
  // VideoSection,
  // Webinars,
} from './components';

import {
  // partners,
  features,
  solutionMap,
  // browsers,
  // advantages,
  // webinars,
  // platforms,
} from './data';

const useStyles = makeStyles(theme => ({
  pagePaddingTop: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
    },
  },
  sectionAlternate: {
    background: 'transparent',
    backgroundImage: `linear-gradient(180deg, ${theme.palette.background.paper} 40%, ${theme.palette.primary.dark} 0%)`,
  },
}));

const Solutions = () => {
  const { solutionName } = useParams();
  const classes = useStyles();

  const navigate = useNavigate();

  const solutionData = solutionMap[solutionName];

  if (!solutionData) {
    navigate("/not-found-cover");
    return;
  }


  return (
    <div>
      {/* <Section className={classes.pagePaddingTop}> */}
      <HeroSection data={solutionData?.banner}/>
      {/* </Section> */}
      <SectionAlternate>
        <SolutionDetails section={solutionData?.sectionHeading} data={solutionData?.features} />
      </SectionAlternate>
      {/*    <Section>
        <>
        <Browsers data={browsers} />
        <Section>
          <Divider />
        </Section>
        <Features data={advantages} />
        </>
      </Section>
      <SectionAlternate innerNarrowed>
        <Webinars data={webinars} />
      </SectionAlternate>
      <Section>
        <Integrations data={platforms} />
      </Section> */}
      {/* <SectionAlternate innerNarrowed className={classes.sectionAlternate}>
        <Subscription />
      </SectionAlternate> */}
    </div>
  );
};

export default Solutions;
